import { render, staticRenderFns } from "./PeriodicRemindersEvaluation.vue?vue&type=template&id=5b64ebd4&scoped=true"
import script from "./PeriodicRemindersEvaluation.vue?vue&type=script&lang=js"
export * from "./PeriodicRemindersEvaluation.vue?vue&type=script&lang=js"
import style0 from "./PeriodicRemindersEvaluation.vue?vue&type=style&index=0&id=5b64ebd4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b64ebd4",
  null
  
)

export default component.exports